// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__39EWF","cardHeader":"styles_cardHeader__3uwg_"};